import React, { useEffect, useState } from 'react'
import styles from './InviteTalentModal.module.css'
import EmailPreviewTemplate from './EmailPreviewTemplate'
import SmsPreviewTemplate from './SmsPreviewTemplate'
import WhatsAppPreviewTemplate from './WhatsAppPreviewTemplate'
import SelectJobModal from '../../QueryPage/components/organisms/SelectJobModal'
import InvitationModal from './InvitationModal'
import { inviteExternalUserApi, postJobMessageApi } from '../../../API/API'
import { useParams } from 'react-router-dom'
import { Spin } from 'antd';
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getExternalUserDetailInit } from '../../../redux/actions'
import { ReactComponent as SelectJobIcon } from '../../../assets/icons/SelectJobIcon.svg'

const templateOptions = ['Template 1', 'Template 2', 'Template 3']

const isPakistanOrIndiaNumber = (phone) => {
  if (!phone) return false
  const normalized = String(phone).replace(/[\s()-]/g, '')
  return normalized.startsWith('+92') || normalized.startsWith('+91')
}

const EditPencilIcon = () => (
  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.69725 16.5767H2.80325L14.2985 5.1065L13.2045 4.0065L1.69725 15.4827V16.5767ZM0.85175 18.28C0.607083 18.28 0.404 18.1992 0.2425 18.0375C0.0808334 17.876 0 17.6729 0 17.4283V15.5077C0 15.2797 0.0466668 15.057 0.14 14.8395C0.233333 14.6218 0.356584 14.4364 0.50975 14.2832L14.363 0.448999C14.5003 0.307666 14.6657 0.1975 14.859 0.1185C15.0523 0.0394998 15.253 0 15.461 0C15.6522 0 15.8434 0.0394998 16.0347 0.1185C16.2261 0.1975 16.4028 0.305666 16.5647 0.442999L17.862 1.72225C18.016 1.88425 18.1283 2.06192 18.199 2.25525C18.2697 2.44858 18.305 2.64283 18.305 2.838C18.305 3.03333 18.2655 3.23083 18.1865 3.4305C18.1075 3.63017 17.9993 3.80067 17.862 3.942L4.00875 17.7702C3.85142 17.9234 3.665 18.0467 3.4495 18.14C3.234 18.2333 3.01225 18.28 2.78425 18.28H0.85175ZM13.7545 4.5505L13.2045 4.0065L14.2985 5.1065L13.7545 4.5505Z" fill="#16191C"/>
  </svg>
)

const getJobDetails = (job) => {
  if (!job) return []
  return [
    { label: 'Title', value: job.title },
    { label: 'Job Type', value: job.type },
    { label: 'Start Date', value: job.startDate },
    { label: 'Location', value: job.location },
    { label: 'Skills', value: job.skills },
  ].filter((detail) => detail.value)
}

const InviteTalentModal = ({ onClose, candidate, searchQuery }) => {
  const { id } = useParams()
  const history = useHistory()
  const dispatch = useDispatch()
  const companyProfileResp = useSelector((state) => state.getCompanyProfileDetailsReducer.resp)
  const localProfiles = JSON.parse(localStorage.getItem('userProfile') || '{}')?.Profiles || {}
  const companyName =
    companyProfileResp?.companyProfile?.CompanyName ||
    companyProfileResp?.Profiles?.CompanyName ||
    localProfiles?.CompanyName ||
    ''
  const employerFirstName =
    companyProfileResp?.companyProfile?.FirstName ||
    companyProfileResp?.Profiles?.FirstName ||
    localProfiles?.FirstName ||
    ''
  const employerLastName =
    companyProfileResp?.companyProfile?.LastName ||
    companyProfileResp?.Profiles?.LastName ||
    localProfiles?.LastName ||
    ''
  const employerName = [employerFirstName, employerLastName].filter(Boolean).join(' ')

  const hasEmail = Array.isArray(candidate?.emails) && candidate.emails.length > 0
  const allPhones = Array.isArray(candidate?.phones) ? candidate.phones : []
  const smsPhones = allPhones.filter((phone) => !isPakistanOrIndiaNumber(phone))
  const hasPhone = allPhones.length > 0
  const hasSmsPhone = smsPhones.length > 0

  const availableMethods = [
    ...(hasEmail ? ['Email'] : []),
    ...(hasSmsPhone ? ['SMS'] : []),
    ...(hasPhone ? ['WhatsApp'] : []),
  ]

  const getInitialMethods = () => {
    if (hasEmail) return ['Email']
    if (availableMethods.length > 0) return [availableMethods[0]]
    return ['Email']
  }

  const [selectedJob, setSelectedJob] = useState(null)
  const [isSending, setIsSending] = useState(false);
  const [selectedMethods, setSelectedMethods] = useState(getInitialMethods)
  const [selectedEmails, setSelectedEmails] = useState(() =>
    candidate?.emails?.length ? [candidate.emails[0]] : []
  )
  const [selectedSmsPhones, setSelectedSmsPhones] = useState(() =>
    smsPhones.length ? [smsPhones[0]] : []
  )
  const [selectedWhatsappPhones, setSelectedWhatsappPhones] = useState(() =>
    allPhones.length ? [allPhones[0]] : []
  )
  const [expandedSections, setExpandedSections] = useState({ email: true, sms: true, whatsapp: true })
  const [selectedTemplate, setSelectedTemplate] = useState('Template 1')
  const [previewChannel, setPreviewChannel] = useState('email')
  const [message, setMessage] = useState(() => {
    const firstName = candidate?.name?.trim()?.split(/\s+/)?.[0] || 'Talent'
    return `Hi ${firstName},\n\nWe'd like to invite you to apply for this opportunity. Your background looks like a great fit.`
  })
  const [jobModalOpen, setJobModalOpen] = useState(false)
  const [avatarError, setAvatarError] = useState(false)
  const [showInvitationModal, setShowInvitationModal] = useState(false)
  const talentFirstName = candidate?.name?.trim()?.split(/\s+/)?.[0] || 'Talent'

  const buildTemplateMessage = (channel, templateName, job) => {
    const jobTitle = job?.title || 'this opportunity'
    const jobLocation = job?.location ? ` in ${job.location}` : ''
    const baseChannel = channel.toLowerCase()

    const base = {
      email: {
        'Template 1': `Hi ${talentFirstName},\n\nWe'd like to invite you to apply for ${jobTitle}${jobLocation}. Your background looks like a great fit.`,
        'Template 2': `Dear ${talentFirstName},\n\nYou have been shortlisted for ${jobTitle}${jobLocation}. Please review the opportunity and reply at your convenience.`,
        'Template 3': `Hello ${talentFirstName},\n\nWe came across your profile and believe you may be a strong fit for ${jobTitle}${jobLocation}.`,
      },
      whatsapp: {
        'Template 1': `Hi ${talentFirstName}, you're invited for ${jobTitle}${jobLocation}. Reply YES if interested.`,
        'Template 2': `Hello ${talentFirstName}! We have an opening for ${jobTitle}${jobLocation}. Would you like to learn more?`,
        'Template 3': `Hi ${talentFirstName}, we think your profile is a strong fit for ${jobTitle}${jobLocation}. Reply if you'd like to proceed.`,
      },
      sms: {
        'Template 1': `Hi ${talentFirstName}, you're invited for ${jobTitle}${jobLocation}. Reply YES if interested.`,
        'Template 2': `Hello ${talentFirstName}, we have a new opportunity for ${jobTitle}${jobLocation}.`,
        'Template 3': `Hi ${talentFirstName}, your profile is shortlisted for ${jobTitle}${jobLocation}.`,
      },
    }

    return base[baseChannel]?.[templateName] || base[baseChannel]?.['Template 1'] || ''
  }

  const getCreditAlertText = (methods) => {
    if (methods.length === 0) return ''

    const parts = []
    if (methods.includes('Email')) parts.push('0.5 credit per email')

    const hasSms = methods.includes('SMS')
    const hasWhatsApp = methods.includes('WhatsApp')
    if (hasSms && hasWhatsApp) {
      parts.push('1 credit each for SMS and WhatsApp messages')
    } else if (hasSms) {
      parts.push('1 credit for SMS')
    } else if (hasWhatsApp) {
      parts.push('1 credit for WhatsApp')
    }

    if (parts.length === 0) return ''
    return `You'll be charged ${parts.join(' and ')}.`
  }

  const toggleMethod = (method) => {
    setSelectedMethods((prev) => {
      const updated = prev.includes(method)
        ? prev.filter((item) => item !== method)
        : [...prev, method]
      return updated
    })
  }

  const toggleSelectionItem = (setList, value) => {
    setList((prev) =>
      prev.includes(value) ? prev.filter((item) => item !== value) : [...prev, value]
    )
  }

  const toggleSelectAll = (items, list, setList) => {
    setList(list.length === items.length ? [] : [...items])
  }

  const toggleSectionExpanded = (key) => {
    setExpandedSections((prev) => ({ ...prev, [key]: !prev[key] }))
  }

  useEffect(() => {
    const methodsLower = selectedMethods.map((m) => m.toLowerCase())
    if (!methodsLower.includes(previewChannel) && methodsLower.length > 0) {
      setPreviewChannel(methodsLower[0])
    }
  }, [selectedMethods])

  useEffect(() => {
    if (candidate?.emails?.length) {
      setSelectedEmails((prev) => {
        const filtered = prev.filter((v) => candidate.emails.includes(v))
        return filtered.length ? filtered : [candidate.emails[0]]
      })
    }
  }, [candidate?.emails])

  useEffect(() => {
    if (smsPhones.length) {
      setSelectedSmsPhones((prev) => {
        const filtered = prev.filter((v) => smsPhones.includes(v))
        return filtered.length ? filtered : [smsPhones[0]]
      })
    }
    if (allPhones.length) {
      setSelectedWhatsappPhones((prev) => {
        const filtered = prev.filter((v) => allPhones.includes(v))
        return filtered.length ? filtered : [allPhones[0]]
      })
    }
  }, [candidate?.phones])

  const [isAiLoading, setIsAiLoading] = useState(false)

  const handleWriteWithAi = async () => {
    if (selectedJob?.JobOrderId) {
      try {
        setIsAiLoading(true)
        const response = await postJobMessageApi(selectedJob.JobOrderId, id)
        const aiMessage = response?.data?.data?.message
        if (aiMessage) {
          setMessage(aiMessage)
        }
      } catch (e) {
        // silently ignore
      } finally {
        setIsAiLoading(false)
      }
    }
  }

  const handleJobSelect = (job) => {
    setSelectedJob(job)
    setMessage(buildTemplateMessage(previewChannel, selectedTemplate, job))
    setJobModalOpen(false)
  }

  const handleTemplateChange = (e) => {
    const newTemplate = e.target.value;
    setSelectedTemplate(newTemplate);
    setMessage(buildTemplateMessage(previewChannel, newTemplate, selectedJob))
  }

  const handlePreviewChannelChange = (channel) => {
    setPreviewChannel(channel)
    if (selectedJob) setMessage(buildTemplateMessage(channel, selectedTemplate, selectedJob))
  }

  const handleInviteCta = () => {
    history.push("/query");
  };

  const handleSendInvite = async () => {
    if (isSending) return;

    try {
      if (!selectedJob || !message.trim()) return;

      setIsSending(true);

      const payload = {
        medium: selectedMethods.map((m) => m.toLowerCase()),
        jobId: selectedJob?._id || selectedJob?.id,
        message: message,
        template: selectedTemplate,
        ...(selectedMethods.includes('Email') && { email: selectedEmails }),
        ...(selectedMethods.includes('SMS') && { sms: selectedSmsPhones }),
        ...(selectedMethods.includes('WhatsApp') && { whatsapp: selectedWhatsappPhones }),
      };

      await inviteExternalUserApi(payload, id);

      dispatch(getExternalUserDetailInit(id));
      setShowInvitationModal(true);
    } catch (error) {
      console.error('Invite API error:', error);
    } finally {
      setIsSending(false);
    }
  };

  const renderSelectionSection = ({ key, title, items, selected, setSelected, creditLabel }) => {
    if (!items || items.length < 1) return null
    const hasMultiple = items.length > 1
    const expanded = hasMultiple ? expandedSections[key] : true
    const allSelected = selected.length === items.length && items.length > 0
    return (
      <div className={styles.selectionSection}>
        <div className={styles.selectionHeader}>
          <span className={styles.selectionTitle}>
            {title} <span className={styles.selectionCount}>{selected.length}/{items.length}</span>
          </span>
          {hasMultiple && (
            <div className={styles.selectionHeaderRight}>
              <input
                type="checkbox"
                className={styles.selectionMasterCheckbox}
                checked={allSelected}
                onChange={() => toggleSelectAll(items, selected, setSelected)}
                aria-label={`Select all ${title}`}
              />
              <button
                type="button"
                className={styles.selectionChevron}
                onClick={() => toggleSectionExpanded(key)}
                aria-label={expanded ? 'Collapse' : 'Expand'}
              >
                {expanded ? '▲' : '▼'}
              </button>
            </div>
          )}
        </div>
        {expanded && (
          <div className={styles.selectionList}>
            {items.map((value, i) => (
              <label key={`${key}-${i}`} className={styles.selectionRow}>
                <span className={styles.selectionRowLeft}>
                  {hasMultiple && (
                    <input
                      type="checkbox"
                      checked={selected.includes(value)}
                      onChange={() => toggleSelectionItem(setSelected, value)}
                    />
                  )}
                  {value}
                </span>
                <span className={styles.selectionCredit}>{creditLabel}</span>
              </label>
            ))}
          </div>
        )}
      </div>
    )
  }

  const emailSelectionValid = !selectedMethods.includes('Email') || selectedEmails.length > 0
  const smsSelectionValid = !selectedMethods.includes('SMS') || selectedSmsPhones.length > 0
  const whatsappSelectionValid =
    !selectedMethods.includes('WhatsApp') || selectedWhatsappPhones.length > 0

  const isSendDisabled =
    !selectedJob ||
    !message.trim() ||
    selectedMethods.length === 0 ||
    !emailSelectionValid ||
    !smsSelectionValid ||
    !whatsappSelectionValid
  const candidateRole = candidate?.role || candidate?.title || 'RN - Med Surg'
  const candidateTag = candidate?.tag || 'External'
  const candidateInitials = candidate?.name?.slice(0, 1)?.toUpperCase() || 'B'
  const showAvatarImage = Boolean(candidate?.avatar) && !avatarError
  const selectedJobDetails = getJobDetails(selectedJob)

  useEffect(() => {
    const previousBodyOverflow = document.body.style.overflow
    const previousHtmlOverflow = document.documentElement.style.overflow

    document.body.style.overflow = 'hidden'
    document.documentElement.style.overflow = 'hidden'

    return () => {
      document.body.style.overflow = previousBodyOverflow
      document.documentElement.style.overflow = previousHtmlOverflow
    }
  }, [])

  if (showInvitationModal) {
    return <InvitationModal onClose={onClose} searchQuery={searchQuery} onCta={handleInviteCta} />
  }

  return (
    <div
      className={styles.overlay}
      onClick={onClose}
      style={jobModalOpen ? { display: 'none' } : undefined}
    >
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className={styles.header}>
          <h2 className={styles.modalTitle}>Invite a Talent</h2>
          <button type="button" className={styles.closeBtn} onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>

        <div className={styles.headerDivider} />

        {/* Main Content Shell */}
        <div className={styles.shell}>
          <div className={styles.grid}>
            {/* Left Form Card */}
            <div className={styles.card}>
              <div className={styles.candidateRow}>
                <div className={styles.candidateLeft}>
                  {showAvatarImage ? (
                    <img
                      src={candidate?.avatar || 'https://i.pravatar.cc/150?u=bonnie'}
                      alt={candidate?.name}
                      className={styles.candidateAvatar}
                      onError={() => setAvatarError(true)}
                    />
                  ) : (
                    <div className={styles.candidateAvatarFallback}>{candidateInitials}</div>
                  )}
                  <span className={styles.onlineDot} />
                </div>

                <div className={styles.candidateMid}>
                  <div className={styles.candidateName}>{candidate?.name || 'Bonnie Williams'}</div>
                  <div className={styles.candidateRole}>{candidateRole}</div>
                </div>

                <div className={styles.candidateBadges}>
                  {/* <div className={styles.aiScoreBadge}>
                    <span className={styles.aiScoreIcon}>✦</span>
                    {candidateScore}
                  </div> */}
                  <div className={styles.externalMiniBadge}>{candidateTag}</div>
                </div>
              </div>

              {/* Select Job */}
              <div className={styles.field}>
                <label className={styles.fieldLabel}>Select Job</label>
                <button
                  type="button"
                  className={`${styles.selectJobBtn} ${selectedJob ? styles.selectJobBtnFilled : ''}`}
                  onClick={() => setJobModalOpen(true)}
                >
                  {selectedJob ? (
                    <>
                      <div className={styles.selectJobCopy}>
                        <div className={styles.selectJobTitle}>{selectedJob.title}</div>
                        <div className={styles.selectJobMeta}>{selectedJob?.location}</div>
                      </div>
                      <span className={styles.editIcon} aria-hidden="true">
                        <EditPencilIcon />
                      </span>
                    </>
                  ) : (
                    <div className={styles.selectJobEmpty}>
                      <span className={styles.selectJobEmptyIcon}><SelectJobIcon/></span>
                      <span>Select a Job</span>
                    </div>
                  )}
                </button>
              </div>

              {/* Methods */}
              <div className={styles.field}>
                <label className={styles.fieldLabel}>
                  How you want to invite? <span className={styles.required}>*</span>
                </label>
                <div className={styles.methodChips}>
                  {(availableMethods.length > 0 ? availableMethods : ['Email', 'SMS', 'WhatsApp']).map((method) => {
                    const active = selectedMethods.includes(method)
                    return (
                      <button
                        key={method}
                        type="button"
                        className={`${styles.methodChip} ${active ? styles.methodChipActive : ''}`}
                        onClick={() => toggleMethod(method)}
                      >
                        <span className={styles.methodChipIcon}>{active ? '×' : '+'}</span>
                        {method}
                      </button>
                    )
                  })}
                </div>
                {getCreditAlertText(selectedMethods) && (
                  <div className={styles.creditAlert}>
                    <span className={styles.creditAlertIcon} aria-hidden="true">⚡</span>
                    {getCreditAlertText(selectedMethods)}
                  </div>
                )}

                {selectedMethods.includes('Email') &&
                  renderSelectionSection({
                    key: 'email',
                    title: 'Select Email',
                    items: candidate?.emails,
                    selected: selectedEmails,
                    setSelected: setSelectedEmails,
                    creditLabel: '0.5 credit',
                  })}

                {selectedMethods.includes('SMS') &&
                  renderSelectionSection({
                    key: 'sms',
                    title: 'Select Phone Number',
                    items: smsPhones,
                    selected: selectedSmsPhones,
                    setSelected: setSelectedSmsPhones,
                    creditLabel: '1 credit',
                  })}

                {selectedMethods.includes('WhatsApp') &&
                  renderSelectionSection({
                    key: 'whatsapp',
                    title: 'Select WhatsApp',
                    items: allPhones,
                    selected: selectedWhatsappPhones,
                    setSelected: setSelectedWhatsappPhones,
                    creditLabel: '1 credit',
                  })}
              </div>

              {/* Template */}
              <div className={styles.field}>
                <label className={styles.fieldLabel}>Message Template</label>
                <div className={styles.selectWrap}>
                  <select
                    className={styles.select}
                    value={selectedTemplate}
                    onChange={handleTemplateChange}
                  >
                    {templateOptions.map((t) => (
                      <option key={t} value={t}>
                        {t}
                      </option>
                    ))}
                  </select>
                  <span className={styles.selectArrow}>▾</span>
                </div>
              </div>

              {/* Message */}
              <div className={styles.field}>
                <div className={styles.fieldTopRow}>
                  <label className={styles.fieldLabel}>
                    Write Message For Talent <span className={styles.required}>*</span>
                  </label>
                  <button type="button" className={styles.aiBtn} onClick={handleWriteWithAi} disabled={!selectedJob || isAiLoading}>
                    <span className={styles.aiIcon}>✦</span> Write with AI
                  </button>
                </div>
                <div className={styles.textareaWrap} style={{ position: 'relative' }}>
                  {isAiLoading && (
                    <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.7)', zIndex: 1, borderRadius: 8 }}>
                      <Spin size="default" />
                    </div>
                  )}
                  <textarea
                    className={styles.textarea}
                    rows={5}
                    placeholder="Write a message to the talent to invite him."
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  />
                </div>
              </div>
            </div>

            {/* Right Preview Card */}
            <div className={`${styles.card} ${styles.previewCard}`}>
              <div className={styles.previewTitle}>Preview Template</div>
              <div className={styles.tabs}>
                {[
                  { key: 'email', label: 'Email' },
                  { key: 'whatsapp', label: 'WhatsApp' },
                  { key: 'sms', label: 'SMS' },
                ]
                  .filter((tab) => selectedMethods.map((m) => m.toLowerCase()).includes(tab.key))
                  .map((tab) => (
                    <button
                      key={tab.key}
                      type="button"
                      className={`${styles.tabBtn} ${previewChannel === tab.key ? styles.tabActive : ''}`}
                      onClick={() => handlePreviewChannelChange(tab.key)}
                    >
                      {tab.label}
                    </button>
                  ))}
              </div>

              <div className={styles.previewCenter}>
                <div className={styles.phoneFrame}>
                  <div className={styles.phoneTopBar}>
                    <span>13:13</span>
                    <span className={styles.phonePill} />
                  </div>
                  <div className={styles.phoneContent}>
                    {previewChannel === 'email' && (
                      <EmailPreviewTemplate
                        talentFirstName={talentFirstName}
                        jobTitle={selectedJob?.title}
                        jobDetails={selectedJobDetails}
                        selectedJob={selectedJob}
                        message={message}
                        selectedTemplate={selectedTemplate}
                        companyName={companyName}
                        employerName={employerName}
                      />
                    )}
                    {previewChannel === 'sms' && (
                      <SmsPreviewTemplate
                        talentFirstName={talentFirstName}
                        jobTitle={selectedJob?.title}
                        jobDetails={selectedJobDetails}
                        message={message}
                        selectedTemplate={selectedTemplate}
                        companyName={companyName}
                      />
                    )}

                    {previewChannel === 'whatsapp' && (
                      <WhatsAppPreviewTemplate
                        talentFirstName={talentFirstName}
                        jobTitle={selectedJob?.title}
                        jobDetails={selectedJobDetails}
                        message={message}
                        selectedTemplate={selectedTemplate}
                        companyName={companyName}
                        employerName={employerName}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className={styles.footer}>
          <button
            type="button"
            className={styles.sendBtn}
            disabled={isSendDisabled || isSending}
            onClick={handleSendInvite}
          >
            {isSending ? (
              <>
                <Spin size="small" style={{ marginRight: 8 }} />
              </>
            ) : (
              <>
                Send Invite <span className={styles.sendArrow}>▶</span>
              </>
            )}
          </button>
        </div>

        {jobModalOpen && (
          <SelectJobModal
            open={jobModalOpen}
            onClose={() => setJobModalOpen(false)}
            onSelect={handleJobSelect}
            zIndex={100100}
          />
        )}

      </div>
    </div>
  )
}

export default InviteTalentModal
